export default __webpack_public_path__ + "static/media/breakfast3.dc33d676.jpeg";